import Box from '@components/Box';
import PlacingOrderAddressDropdownItem
  from '../PlacingOrderAddressDropdownItem/PlacingOrderAddressDropdownItem';
import PlacingOrderAddressEnglish from '../PlacingOrderAddressEnglish';
import SelectContainer from '@containers/SelectContainer';
import SelectDropdown from '@components/SelectDropdown';
import TextInputContainer from '@containers/TextInputContainer';
import { AddressTemplate, TLabelSelectedItem } from '@api/apiClient';
import { Column, Row } from '@components/Grid';
import {
  countries,
  countryKeyExtractor,
  CountrySelectOption,
  CountrySelectValue,
  CountryType
} from '@components/CountrySelect';
import { IPlacingOrderAddressFieldsThirdProps } from '../../types';
import { useTranslation } from 'react-i18next';

const PlacingOrderAddressFieldsThird: React.FC<IPlacingOrderAddressFieldsThirdProps> = (props: IPlacingOrderAddressFieldsThirdProps): React.ReactElement => {
  const {
    control,
    country,
    emptyAddressWithUpdate,
    fullListAddresses,
    handlerGetFullAddress,
    handlerOnClickDeleteAddress,
    handlerSetCurrentAddress,
    labelSelectedItem,
    withFullAddressInEnglish,
    handlerSetSelectedSuggestion,
  } = props;

  const { t } = useTranslation();

  return (
      <>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <SelectDropdown<AddressTemplate>
                  defaultSelectedItem={emptyAddressWithUpdate}
                  items={fullListAddresses}
                  keyExtractor={(item: TLabelSelectedItem) => item.id}
                  label={t('placingOrderModalWindow.form.address.addressTitle')}
                  labelSelectedItem={() => handlerGetFullAddress(labelSelectedItem)}
                  onItemSelect={(id: string) => handlerSetCurrentAddress(id)}
                  renderItem={(props: { item: TLabelSelectedItem }) => (
                      <PlacingOrderAddressDropdownItem
                          handlerGetFullAddress={handlerGetFullAddress}
                          handlerOnClickDeleteAddress={handlerOnClickDeleteAddress}
                          {...props}
                      />
                  )}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={5}>
            <Box
                mb={5}
                pr={4}
            >
              <SelectContainer<CountryType, AddressTemplate>
                  control={control}
                  disabled={country !== 'unknown'}
                  items={countries.filter((item: CountryType) => item.id === 'RU')}
                  keyExtractor={countryKeyExtractor}
                  name="address.countryCode"
                  renderItem={CountrySelectOption}
                  renderSelectedItem={CountrySelectValue}
                  title={t('placingOrderModalWindow.form.address.country')}
              />
            </Box>
          </Column>
          <Column phone={7}>
            <Box mb={5}>
              <TextInputContainer
                  control={control}
                  name="address.city"
                  title={t('placingOrderModalWindow.form.address.city')}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <TextInputContainer
                  control={control}
                  name="address.street"
                  onChange={handlerSetSelectedSuggestion}
                  title={t('placingOrderModalWindow.form.address.street')}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={2}>
            <Box
                mb={8}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  name="address.house"
                  title={t('placingOrderModalWindow.form.address.house')}
              />
            </Box>
          </Column>
          <Column phone={3}>
            <Box
                mb={8}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  name="address.flat"
                  title={t('placingOrderModalWindow.form.address.flat')}
              />
            </Box>
          </Column>
          <Column phone={7}>
            <Box mb={8}>
              <TextInputContainer
                  control={control}
                  name="address.zipCode"
                  title={t('placingOrderModalWindow.form.address.zipCode')}
              />
            </Box>
          </Column>
        </Row>
        {withFullAddressInEnglish && (
            <PlacingOrderAddressEnglish control={control}/>
        )}
      </>
  );
};

export default PlacingOrderAddressFieldsThird;
